import React, { Suspense, useEffect, useState } from 'react';
import { useFirestore } from 'react-redux-firebase';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@mui/material';

import { getCart } from 'redux/slices/cart';
import { signOut } from 'redux/slices/auth';
import { getNotifications } from 'redux/slices/notification';

import LoadingScreen from 'components/LoadingScreen';

import Sidebar from 'components/Sidebar';

import NavbarGeneral from './NavbarGeneral';
import NavbarExamPage from './NavbarExamPage';
import NavbarQuiz from './NavbarQuiz';

const Navbar = () => {
  const dispatch = useDispatch();

  const firestore = useFirestore();

  const { pathname } = useLocation();

  const logOut = () => dispatch(signOut());

  const user = useSelector((state) => state.auth.user);

  const [open, setOpen] = useState(false);

  const isExamPagePath =
    pathname.includes('/exam/') || pathname.includes('/exam-result/');

  const isQuizPath = pathname.includes('/quiz/');

  const isEvaluationPath = pathname.includes('/evaluation');

  const renderNavbarDekstop = () => {
    if (isExamPagePath) {
      return <NavbarExamPage logOut={logOut} />;
    }

    if (isQuizPath) {
      return <NavbarQuiz />;
    }

    return <NavbarGeneral setOpenMenu={setOpen} />;
  };

  useEffect(() => {
    if (user.id) {
      dispatch(getNotifications(firestore, user.id));
      dispatch(getCart(user.id));
    }
  }, [dispatch, user.id, firestore]);

  return (
    <>
      {renderNavbarDekstop()}

      {/* SidebarMenu disabled on exam and evaluation page */}
      {!isExamPagePath && !isEvaluationPath && !isQuizPath && (
        <Sidebar open={open} setOpen={setOpen} />
      )}

      <Box>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </Box>
    </>
  );
};

export default Navbar;
